<template minapp='mpx' xlang='wxml'>
  <from-item isShow="{{isShow}}" 
    isRequiredShow="{{isRequiredShow}}" 
    label="证件类型" 
  >
    <view slot="input" class="es-content__birth-data-input" bindtap="showTypeSelect">
      <view style="flex:1">
        <!-- <picker mode="date" value="{{innerValue}}" start="{{startDate}}" end="2099-12-31" bindchange="bindDateChange"> -->
          <view class="picker">
            <view wx:if="{{cardType.card_name}}">{{cardType.card_name}}</view>
            <!-- <view wx:else class="placeholder">11</view> -->
          </view>
        <!-- </picker> -->
      </view>
      <es-icon name='angle-right' size="16" color="#999999"></es-icon>
    </view>
  </from-item>
  <drawer-bottom show="{{isCardTypeShow}}" bind:close="showTypeSelect">
    <view border slot='header'>
      <view class="es-credentials__drawer-header">
        <view class="es-credentials__drawer-header-title">请选择证件类型</view>
        <view class="es-credentials__drawer-header-right" bindtap="showTypeSelect">
          <es-icon class="es-credentials__drawer-close" size="24" color="#999999" name="close-filled"></es-icon>
        </view>
      </view>
    </view>
    <view wx:for="{{cardTypeList}}">
      <es-cell 
        border
        useTitle
        custom-class="es-credentials__miniapp_drawer_cell" 
        class="es-cell-custom" 
        wx:if="{{item.code != cardType.code}}" 
        bind:click="selectCardType(item)" 
      >
        <view slot='title'>
          <text>{{item.name}}</text>
          <text class="es-credentials__card-no" wx:if="{{item.display_card_no}}">{{item.display_card_no}}</text>
        </view>
      </es-cell>
      <es-cell 
        border 
        useTitle
        custom-class="es-credentials__miniapp_drawer_cell" 
        class="es-cell-custom" 
        wx:else 
        align='right' 
        bind:click="showTypeSelect"
      >
        <view slot='title'>
          <text>{{item.name}}</text>
          <text class="es-credentials__card-no" wx:if="{{item.display_card_no}}">{{item.display_card_no}}</text>
        </view>
        <es-icon class="es-credentials__checked" name='check-filled'></es-icon>
      </es-cell>
    </view>
    <view style="height:80px;width:100%"/>   
  </drawer-bottom>
</template>

<script>
import { watch } from "@mpxjs/core";

  import { createComponent } from '@didi/es-mpx-creator'
  import { formatDate } from '@didi/es-mpx-shared'
  import { hasRequired } from '@/utils'
  createComponent({
    classes: [],
    data: {
      // innerValue:'',
      isCardTypeShow: false,
    },
    props: {
      value: {
        type: [Array, String],
        value: []
      },
      isRequiredShow: {
        type: Boolean,
        value: false
      },
      isShow: {
        type: Boolean,
        value: false
      },
      cardType: {
        type: Object,
        value: {}
      },
    },
    computed: {
      cardTypeList(){
        return [
          {
              "code": "1",
              "name": "二代身份证"
          },
          {
              "code": "B",
              "name": "护照"
          },
          {
              "code": "H",
              "name": "外国人永久居留身份证"
          },
          {
              "code": "2",
              "name": "港澳台居民居住证"
          },
          {
              "code": "G",
              "name": "台胞证"
          },
          {
              "code": "C",
              "name": "回乡证"
          },
          
        ]
      }
    },
    methods: {
      // bindChange(e) {
      //   this.innerValue = e.detail.value
      // },
      // 证件类型弹窗
      showTypeSelect(e) {
        // h5 让所有的输入框失去焦点
        if (__mpx_mode__ === 'web') {
          document.querySelectorAll('input')?.forEach((item) => {
            item.blur()
          })
        }

        this.$nextTick(() => {
          setTimeout(() => {
            this.isCardTypeShow = !this.isCardTypeShow
          }, 250)
        })

        if (e && e.detail && e.stopPropagation && e.preventDefault) {
          e.stopPropagation()
          e.preventDefault(true)
        }
      },
      // 切换证件类型
      selectCardType(item) {
        this.id_no = '' //todo
        this.expire_date = '' //todo
        console.warn('-----selectCardType',item,);
        // this.$trigger('input', {
        //   origin: this.cardType,
        //   target: { ...item, card_name: item.name, card_type: item.code }
        // })
        this.$trigger('input', { value: [{ ...item, card_name: item.name, card_type: item.code }] })
        this.showTypeSelect()
      },
    },
    watch:{
      value(val) {
        // this.innerValue = this.formatBirthData(val)
      },
      //将数据回传
      // innerValue(newValue) {
      //   this.$trigger( 'input', {value:newValue} )
      // },
    },
    mounted() {
      // this.innerValue = this.value
    }
  })
</script>

<style lang='stylus' scoped>
+b('content')
  +e('birth-data-input')
    display flex
    width 100%
    justify-content space-between
    align-items center
.placeholder{
  color #999999
}
+b('credentials')
    margin-bottom 16px
    /deep/ .placeholder
      color #999999 !important
    +e('type')
      display flex
    +e('type-select')
      display flex
      /deep/ .delete
        font-size 20px !important
        color #999999 !important
        padding-left 12px
    // 小程序用
    +e('miniapp_cell')
      height 54px
      color #333333
      padding 10px 0 !important
      &::after
        border-bottom 1px solid #f0f2f7
        left 90px !important
        right 0 !important
    // 小程序用
    +e('miniapp_drawer_cell')
      padding 10px 0 !important
      &::after
        border-bottom 1px solid #eeeeee !important
        left 0 !important
        right 0 !important
    +e('type-text')
      flex 1
      display flex
    +e('type-tag')
      color #1473ff
      border 1px solid #73ACFF
      border-radius 2px
      margin-left 4px
      display inline-block
      line-height 1
      font-size 12px
      padding 2px
      transform scale(0.83)
      align-self center
      white-space nowrap
    +e('type-change')
      color #1473FF
      font-size 12px
      display inline-block
      transform scale(0.9)
      align-self center
    +e('checked')
      color #1473ff
      font-size 20px
    +e('drawer')
      /deep/ .drawer-container
        height auto
      /deep/ .drawer-main
        height auto
    +e('drawer-content')
      display flex
      flex-direction column
    +e('drawer-footer')
      padding 16px 0
      background-color #ffffff
      /deep/ .es-button
        border-radius 8px
    +e('drawer-header')
      display flex
      height 60px
      align-items center
    +e('drawer-header-title')
      flex 1
      text-align center
      font-size 16px
      font-weight 500
      margin-left 56px
      font-family PingFangSC-Medium
    +e('drawer-header-right')
      width 56px
      text-align center
    +e('drawer-header-close')
      color #999999 !important
    +e('required-text')
      color #F93822
    +e('card-no')
      margin-left 8px
    +e('name-box')
      display flex
      width 88px
      margin-right 9px
</style>

<script name='json'>
  module.exports = {
    component: true,
    "usingComponents": {
      'es-icon': '@didi/es-mpx-ui/lib/icon',
      'es-cell': '@didi/es-mpx-ui/lib/cell',
      'es-field': '@didi/es-mpx-ui/lib/field',
      'from-item': './from-item',
      'drawer-bottom': '../../drawer-bottom',
    }
  }
</script>

